export const BuilderComponentDeadCompTranslationKeys = {
	NAMESPACE: 'PLATFORM',
	BUILDER_LOADING_ERROR_HEADER_KEY: 'PLATFORM_Viewer_Builder_Component_Didnt_Load_Header',
	BUILDER_LOADING_ERROR_HEADER_DEFAULT: 'Component Failed to Load',
	BUILDER_LOADING_ERROR_TEXT1_KEY: 'PLATFORM_Viewer_Builder_Component_Didnt_Load_Sub_Text1',
	BUILDER_LOADING_ERROR_TEXT1_DEFAULT: 'Check your internet and refresh this page.',
	BUILDER_LOADING_ERROR_TEXT2_KEY: 'PLATFORM_Viewer_Builder_Component_Didnt_Load_Sub_Text2',
	BUILDER_LOADING_ERROR_TEXT2_DEFAULT: "If that doesn't work, contact us.",
} as const
